/**
 * Hide Judge.me "Write a review" UI from the theme (draft-safe; no app settings change).
 * Patches jdgmSettings before the widget boots, then cleans up any late-rendered controls.
 */
(function () {
  const ROOT = '.section-matcha-product-reviews';
  const HIDE_SELECTORS = [
    '.jdgm-write-rev-link',
    '.jdgm-rev-widg__write-review-link',
    '.jdgm-rev-widg__summary-actions',
    '.jdgm-form-wrapper',
    '.jdgm-form',
    '.jdgm-cancel-rev',
    'button.jdgm-btn--write-review',
    '.jdgm-widget-actions__write-review',
  ];

  function patchJudgeMeSettings() {
    if (!window.jdgmSettings || typeof window.jdgmSettings !== 'object') return;
    window.jdgmSettings.disable_web_reviews = true;
  }

  function hideElement(el) {
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
    el.tabIndex = -1;
  }

  function hideWriteReviewUi() {
    document.querySelectorAll(ROOT).forEach((scope) => {
      HIDE_SELECTORS.forEach((selector) => {
        scope.querySelectorAll(selector).forEach(hideElement);
      });

      scope.querySelectorAll('a, button').forEach((el) => {
        const label = (el.textContent || '').trim().toLowerCase();
        if (label === 'write a review' || label === 'schrijf een review') {
          hideElement(el);
        }
      });
    });
  }

  function run() {
    patchJudgeMeSettings();
    hideWriteReviewUi();
  }

  run();

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('jdgm.doneSetup', run);

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
